import { Sentry } from "@/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Apply persisted text-scale before first render so public pages
// (which never mount TextScaleControls) inherit the user's last choice.
try {
  const v = parseFloat(localStorage.getItem("erio_text_scale"));
  if (v && v >= 0.9 && v <= 1.3) {
    document.documentElement.style.fontSize = `${16 * v}px`;
    document.documentElement.style.setProperty("--erio-text-scale", String(v));
    document.documentElement.setAttribute("data-text-scale", String(v));
  }
} catch {
  /* localStorage disabled — default 100% is fine */
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

function AppErrorFallback() {
  return (
    <div
      data-testid="app-error-fallback"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        fontFamily: "Inter, system-ui, sans-serif",
        background: "#f6f5fb",
        color: "#160B2E",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "20px", fontWeight: 600 }}>Something went wrong</h1>
      <p style={{ color: "#6b6b72", maxWidth: "420px" }}>
        An unexpected error occurred. Please refresh the page — if it keeps happening, contact us at
        info@ekselens.com.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: "8px",
          background: "#7737F6",
          color: "#fff",
          border: 0,
          borderRadius: "8px",
          padding: "10px 18px",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Reload
      </button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
